import { InfoIcon } from 'lucide-react';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { CrmNoteDTO } from '../../../server/dto/crm-note-dto.ts';
import { BaseConfirmationDialog } from '../../dialog/confirmation-dialog.tsx';
import { DialogStateManager, useDialog } from '../../dialog/dialog-provider.tsx';

export type NotePinConfirmationDialogProps = {
    note: CrmNoteDTO;
    onConfirm: () => void;
};

export const NotePinConfirmationDialog = DialogStateManager.create<NotePinConfirmationDialogProps>(
    ({ onConfirm }) => {
        const { remove } = useDialog();
        const { t } = useLocale('notes');

        return (
            <BaseConfirmationDialog
                focus="destroy"
                icon={InfoIcon}
                title={t('notes__pin_confirmation_title')}
                description={t('notes__pin_confirmation_description')}
            >
                <BaseConfirmationDialog.Actions>
                    <BaseConfirmationDialog.RejectButton onClick={remove}>
                        {t('notes__pin_confirmation_cancel')}
                    </BaseConfirmationDialog.RejectButton>
                    <BaseConfirmationDialog.AcceptButton
                        onClick={() => {
                            onConfirm();
                            remove();
                        }}
                    >
                        {t('notes__pin_confirmation_confirm')}
                    </BaseConfirmationDialog.AcceptButton>
                </BaseConfirmationDialog.Actions>
            </BaseConfirmationDialog>
        );
    },
);
